/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.18",
    versionName: "0.6.0-nightly.2026.8.18",
    versionChannel: "nightly",
    buildDate: "2026-08-18T00:45:35.802Z",
    commitHash: "bb8f4f9aa46a4567fa4400666e197da35f6459a0",
};
